<div class="mat-elevation-z8">
  <!-- Desktop/Tablet Table View -->
  <div class="table-container desktop-view">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <ng-container matColumnDef="ownerDocumentsCpfCnpj">
        <th mat-header-cell *matHeaderCellDef>Proprietário do Acesso</th>
        <td mat-cell *matCellDef="let element">
          @if(element.ownerDocumentsCpfCnpj && element.ownerDocumentsCpfCnpj.length == 11){
          <div class="owner-access">
            <div>
              <span>{{ getUserName(element.ownerDocumentsCpfCnpj) }}</span> <br />
              <span>{{ element.ownerDocumentsCpfCnpj | cpfMask }}</span>
            </div>
            <div>
              @if(getUserCertified(element.ownerDocumentsCpfCnpj)) {
              <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                matTooltip="Certificado Hub Medical" class="certification-icon" (error)="onImageError($event)" />
              } @else {
              <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado" matTooltip="Não certificado"
                class="certification-icon" (error)="onImageError($event)" />
              }
            </div>
          </div>
          }

          @if(element.ownerDocumentsCpfCnpj && element.ownerDocumentsCpfCnpj.length == 14){
          <div>
            <div class="owner-access">
              <div>
                <span>{{ getCompanyName(element.ownerDocumentsCpfCnpj) }}</span>
                <br />
                <span>{{ element.ownerDocumentsCpfCnpj | cnpjMask }}</span>
              </div>
              <div>
                @if(getCompanyCertified(element.ownerDocumentsCpfCnpj)) {
                <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                  matTooltip="Certificado Hub Medical" class="certification-icon" />
                } @else {
                <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado" matTooltip="Não certificado"
                  class="certification-icon" />
                }
              </div>
            </div>
          </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="grantedCompanyCnpj">
        <th mat-header-cell *matHeaderCellDef>Empresa com Acesso</th>
        <td mat-cell *matCellDef="let element">
          <div>
            <span>{{ getCompanyName(element.grantedCompanyCnpj!) }}</span>
            @if(element.grantedCompanyCnpj && getCompanyCertified(element.grantedCompanyCnpj)) {

            <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
              matTooltip="Certificado Hub Medical" width="20px" height="20px" (error)="onImageError($event)" />
            } @else {
            <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado" matTooltip="Não certificado"
              width="20px" height="20px" (error)="onImageError($event)" />
            }

            <span>{{ element.grantedCompanyCnpj | cnpjMask }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="grantedDate">
        <th mat-header-cell *matHeaderCellDef>Data de Concessão</th>
        <td mat-cell *matCellDef="let element">
          {{ element.grantedDate | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="revokedDate">
        <th mat-header-cell *matHeaderCellDef>Data de Revogação</th>
        <td mat-cell *matCellDef="let element">
          {{ element.revokedDate | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Ativo</th>
        <td mat-cell *matCellDef="let element">
          {{ element.active == true ? "Sim" : "Não" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let element">
          @if(!granted && owner) {
          <button mat-button color="primary" (click)="toggleActive(element)">
            {{ !element.active ? "Ativar" : "Desativar" }}</button>}
          @if(granted && !owner && element.grantedDate && !element.revokedDate) {
          <button mat-button color="primary" (click)="seeFilesList(element)">
            Ver documentos</button>}
          <button mat-button color="primary" (click)="deleteDocumentSharing(element.id!)">Excluir</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- Mobile Card View -->
  <div class="mobile-view">
    <div class="mobile-card mat-elevation-z2" *ngFor="let element of documentSharing">
      <div class="card-header">
        <span class="card-id">ID: {{ element.id }}</span>
        <div class="card-actions">
          @if(!granted && owner) {
          <button mat-icon-button color="primary" (click)="toggleActive(element)"
            [matTooltip]="!element.active ? 'Ativar' : 'Desativar'">
            <mat-icon>{{ !element.active ? 'play_arrow' : 'pause' }}</mat-icon>
          </button>
          }
          @if(granted && !owner && element.grantedDate && !element.revokedDate) {
          <button mat-icon-button color="primary" (click)="seeFilesList(element)" matTooltip="Ver documentos">
            <mat-icon>visibility</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="deleteDocumentSharing(element.id!)" matTooltip="Excluir">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div class="card-content">
        <div class="info-section">
          <div class="info-label">Proprietário do Acesso</div>
          <div class="info-value">
            @if(element.ownerDocumentsCpfCnpj && element.ownerDocumentsCpfCnpj.length == 11){
            <div class="owner-info">
              <div class="owner-details">
                <span class="owner-name">{{ getUserName(element.ownerDocumentsCpfCnpj) }}</span>
                <span class="owner-document">{{ element.ownerDocumentsCpfCnpj | cpfMask }}</span>
              </div>
              <div class="certification-badge">
                @if(getUserCertified(element.ownerDocumentsCpfCnpj)) {
                <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                  matTooltip="Certificado Hub Medical" width="20px" height="20px" (error)="onImageError($event)" />
                } @else {
                <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado" matTooltip="Não certificado"
                  width="20px" height="20px" (error)="onImageError($event)" />
                }
              </div>
            </div>
            }

            @if(element.ownerDocumentsCpfCnpj && element.ownerDocumentsCpfCnpj.length == 14){
            <div class="owner-info">
              <div class="owner-details">
                <span class="owner-name">{{ getCompanyName(element.ownerDocumentsCpfCnpj) }}</span>
                <span class="owner-document">{{ element.ownerDocumentsCpfCnpj | cnpjMask }}</span>
              </div>
              <div class="certification-badge">
                @if(getCompanyCertified(element.ownerDocumentsCpfCnpj)) {
                <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                  matTooltip="Certificado Hub Medical" width="20px" height="20px" />
                } @else {
                <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado" matTooltip="Não certificado"
                  width="20px" height="20px" />
                }
              </div>
            </div>
            }
          </div>
        </div>

        <div class="info-section">
          <div class="info-label">Empresa com Acesso</div>
          <div class="info-value">
            <div class="company-info">
              <span class="company-name">{{ getCompanyName(element.grantedCompanyCnpj!) }}
              @if(element.grantedCompanyCnpj && getCompanyCertified(element.grantedCompanyCnpj)) {
              <img src="assets/icons/icon_certificado_concedido.svg" alt="Certificado Hub Medical"
                matTooltip="Certificado Hub Medical" width="20px" height="20px" (error)="onImageError($event)" />
              } @else {
              <img src="assets/icons/icon_certificado_ausente.svg" alt="Não certificado" matTooltip="Não certificado"
                width="20px" height="20px" (error)="onImageError($event)" />
              }</span>
              <span class="company-document">{{ element.grantedCompanyCnpj! | cnpjMask }}</span>
            </div>
          </div>
        </div>

        <div class="dates-section">
          <div class="date-info">
            <div class="info-label">Data de Concessão</div>
            <div class="info-value">{{ element.grantedDate | date : "dd/MM/yyyy HH:mm" }}</div>
          </div>
          <div class="date-info">
            <div class="info-label">Data de Revogação</div>
            <div class="info-value">{{ element.revokedDate | date : "dd/MM/yyyy HH:mm" }}</div>
          </div>
        </div>

        <div class="status-section">
          <div class="info-label">Status</div>
          <div class="info-value">
            <span class="status-badge" [class.active]="element.active" [class.inactive]="!element.active">
              {{ element.active ? "Ativo" : "Inativo" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>